import styled from 'styled-components';

export const StyledCardDeck = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ gap }) => gap}px;
  justify-content: ${({ center }) => (center ? 'center' : 'flex-start')};
`;
